import { Typography, TypographyProps } from "@mui/material";
import { FC } from "react";

interface ICPSectionTitleProps extends Omit<TypographyProps, "variant"> {
  /** The title text to display */
  children: React.ReactNode;
}

/**
 * Reusable typography component for ICP section titles
 * Provides consistent styling across all ICP sections
 */
export const ICPSectionTitle: FC<ICPSectionTitleProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Typography
      variant="h6"
      sx={{
        fontSize: "20px",
        fontWeight: 300,
        letterSpacing: -0.5,
        color: "#3a3a3a",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};
